var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"is-reset link-add-time i-only is-muted",on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }